 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLPRAISE from '@/components/xhtml/praise'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPY from '@/components/xhtml/copy'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLPRELUDE from '@/components/xhtml/prelude'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLPART01 from '@/components/xhtml/part01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLPART02 from '@/components/xhtml/part02'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH08 from '@/components/xhtml/ch08'
 import XHTMLPART03 from '@/components/xhtml/part03'
 import XHTMLCH09 from '@/components/xhtml/ch09'
 import XHTMLCH10 from '@/components/xhtml/ch10'
 import XHTMLCH11 from '@/components/xhtml/ch11'
 import XHTMLCH12 from '@/components/xhtml/ch12'
 import XHTMLPART04 from '@/components/xhtml/part04'
 import XHTMLCH13 from '@/components/xhtml/ch13'
 import XHTMLCH14 from '@/components/xhtml/ch14'
 import XHTMLEPILOGUE from '@/components/xhtml/epilogue'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLACK from '@/components/xhtml/ack'
 import XHTMLENDNOTES from '@/components/xhtml/endnotes'
 import XHTMLBIB from '@/components/xhtml/bib'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLAUTHORS from '@/components/xhtml/authors'
 import XHTMLBACK01 from '@/components/xhtml/back01'
 import XHTMLBACK02 from '@/components/xhtml/back02'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/prelude",
 			"name" : "xhtml/prelude",
 			"component" : XHTMLPRELUDE
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
 		{
 			"path" : "/xhtml/part01",
 			"name" : "xhtml/part01",
 			"component" : XHTMLPART01
 		},
 		{
 			"path" : "/xhtml/ch02",
 			"name" : "xhtml/ch02",
 			"component" : XHTMLCH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js